import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { label: "Progetti", path: "/admin", end: true, testId: "admin-tab-projects" },
  { label: "Immagini sito", path: "/admin/immagini", testId: "admin-tab-images" },
  { label: "Testi sito", path: "/admin/testi", testId: "admin-tab-texts" },
  { label: "Clienti", path: "/admin/clienti", testId: "admin-tab-clients" },
  { label: "Richieste", path: "/admin/richieste", testId: "admin-tab-contacts" },
];

const isLiveDomain = window.location.hostname.includes("nicolaverardo.it");

const PreviewBanner = () =>
  isLiveDomain ? null : (
    <div data-testid="admin-preview-banner" className="bg-gold text-night text-[11px] font-medium tracking-[0.08em] px-6 py-2.5 text-center">
      AMBIENTE DI LAVORO (anteprima) — le modifiche fatte qui NON vanno sul sito live. Per modificare il sito vero usa <strong>www.nicolaverardo.it/admin</strong>
    </div>
  );

const AdminLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-[#26292E]">
      <PreviewBanner />
      <header className="border-b border-line px-6 sm:px-10 py-5 flex items-center justify-between gap-6">
        <div className="leading-none">
          <p className="text-sm font-semibold tracking-[0.2em] text-bone">NICOLA VERARDO</p>
          <p className="mt-1 text-[10px] font-mono tracking-[0.35em] text-fog">GESTIONE CONTENUTI</p>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/"
            data-testid="admin-view-site-link"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2.5 border border-line text-fog text-xs tracking-[0.15em] hover:text-bone hover:border-fog transition-[color,border-color] duration-300"
          >
            VEDI IL SITO <ExternalLink size={12} />
          </Link>
          <button
            onClick={handleLogout}
            data-testid="admin-logout-button"
            className="inline-flex items-center gap-2 px-4 py-2.5 border border-line text-fog text-xs tracking-[0.15em] hover:text-gold hover:border-gold transition-[color,border-color] duration-300"
          >
            ESCI <LogOut size={12} />
          </button>
        </div>
      </header>
      <nav className="border-b border-line px-6 sm:px-10 flex gap-8" aria-label="Navigazione admin">
        {TABS.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            data-testid={tab.testId}
            className={({ isActive }) =>
              `py-4 text-xs font-medium tracking-[0.2em] uppercase border-b-2 -mb-px transition-[color,border-color] duration-300 ${
                isActive ? "text-bone border-gold" : "text-fog border-transparent hover:text-bone"
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <div className="px-6 sm:px-10 py-10 max-w-6xl">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
